import React, { useEffect, useState } from 'react';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { Location, VisitReason } from '@/common/types';
import { resultIsError } from '@/services/HttpService';
import { MultiSelectField } from '../../Practitioners/MultiSelectField/MultiSelectField';

interface Props {
    selectedIds: number[];
    onChange: (ids: number[]) => void;
}

export const OrganizationVisitReasonsContainer = ({ selectedIds, onChange }: Props) => {
    const { httpService } = useHttpContext();
    const [allVisitReasons, setAllVisitReasons] = useState<VisitReason[]>([]);

    useEffect(() => {
        (async () => {
            const res = await httpService.getAdminVisitReasons();
            if (!resultIsError(res)) {
                setAllVisitReasons(res);
            }
        })();
    }, []);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const id = parseInt(event.target.name);
        const next = event.target.checked ? [...selectedIds, id] : selectedIds.filter((i) => i !== id);
        onChange(next);
    };

    const handleSelectAll = () => {
        onChange(allVisitReasons.map((vr) => vr.id));
    };

    const handleClearSelection = () => {
        onChange([]);
    };

    const options = allVisitReasons.map((vr) => ({ id: vr.id, name: vr.reason }));

    return (
        <div style={{ minWidth: '425px' }}>
            <MultiSelectField
                label="Visit Reasons"
                options={options as Location[]}
                selected={selectedIds}
                handleRadioChange={handleChange}
                handleSelectAll={handleSelectAll}
                handleClearSelection={handleClearSelection}
            />
        </div>
    );
};
